import { SprintStatus } from '../../entity/SprintEntity'

export type ReferencedEntity = {
  uuid: string
  name: string
}
export type ReferencedEntityWithIcon = ReferencedEntity & {
  iconUrl?: string
  path?: string
  parentUuid?: string
}
export type ReferencedEntityWithBackgroundColor = ReferencedEntity & {
  backgroundColor: string
}
export type ReferencedSprintEntity = ReferencedEntity & {
  num: number
  // スプリント一覧の応答には含まれるが、WBSアイテムの応答や
  // referenced_values には含まれないため任意とする。
  status?: SprintStatus
  startDate?: string
  endDate?: string
}

export const REFERENCED_ENTITY_SEARCH_LIMIT = 10
